import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import React from "react";
import { fetchSystemInfo } from "services/system";

export const SystemVersion: React.FC = () => {
  const [version, setVersion] = React.useState("loading...");
  React.useEffect(() => {
    fetchSystemInfo().then((data) => {
      setVersion(data.version);
    });
  }, []);

  return (
    <div>
      <InfoCircleOutlined />
      <span>系统版本：{version}</span>
    </div>
  );
};
const getCurrentTimeString = () => dayjs().format("YYYY-MM-DD HH:mm:ss");
export const CurrentTime: React.FC = () => {
  const [text, setText] = React.useState(getCurrentTimeString());
  React.useEffect(() => {
    const interval = setInterval(
      () => setText(getCurrentTimeString()),
      1000
    );
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div>
      <ClockCircleOutlined />
      <span>{text}</span>
    </div>
  );
};

const links = [<SystemVersion key="version" />, <CurrentTime key="time" />];

export default links;
